<template>

<app-page class="page">

	<com-head />

	<app-page-inner class="page-inner">

		<app-page-title :text="page.title" />

		<app-page-text :html="page.content" />

	</app-page-inner>

</app-page>

</template>

<script>

export default {

	components: {
		'com-head': () => import('./common/Head')
	},

	computed: {

		page: function() {

			var page = this.$_.findWhere(this.pages.other, {
				url: this.$route.params.page
			})

			return (page) ? page : this.pages.notfound

		}

	}

}

</script>

<style scoped>

.page {
	background-repeat: no-repeat;
	background-position: calc(50% + 400px) 0px;
}

.is-mobile .page {
	background-size: 500px auto;
	background-position: 50% 0px;
}

.page-inner {
	padding: 50px 20px 100px 20px;
}

.is-mobile .page-inner {
	padding: 30px 15px 30px 15px;
}

</style>
